export default {
    path: '/valueAddedServices',
    title: '增值服务',
    // icon: 'none',
    iconfont: 'icon-menu-user',
    children: (pre => [
        { path: `${pre}index`, title: '增值服务', icon: 'user', iconfont: 'icon-menu-quanxian' },
    ])('/valueAddedServices/')
  }
    